export enum DocumentationActions {
  BEGIN_DOCUMENTATION_STEP = 'inicio_doc_empresa',
  DOCUMENTATION_TAB_ARTICLES_OF_INCORPORATION = 'aba_contrato',
  SAVE_BUTTON_DOCUMENTATION_TAB_ARTICLES_OF_INCORPORATION = 'salvar_contrato',
  DOCUMENTATION_TAB_BANK_STATEMENT = 'aba_extrato',
  SAVE_BUTTON_DOCUMENTATION_TAB_BANK_STATEMENT = 'salvar_extrato',
  DOCUMENTATION_TAB_SIMPLES_NACIONAL = 'aba_simples',
  SAVE_BUTTON_DOCUMENTATION_TAB_SIMPLES_NACIONAL = 'salvar_simples',
  DOCUMENTATION_TAB_BALANCE_SHEET = 'aba_balanco',
  SAVE_BUTTON_DOCUMENTATION_TAB_BALANCE_SHEET = 'salvar_balanco',
  DOCUMENTATION_TAB_DRE = 'aba_dre',
  SAVE_BUTTON_DOCUMENTATION_TAB_DRE = 'salvar_dre',
  DOCUMENTATION_TAB_PHOTOS = 'aba_fotos',
  SAVE_BUTTON_DOCUMENTATION_TAB_PHOTOS = 'salvar_fotos',
  DOCUMENTATION_TAB_VIDEOS = 'aba_videos',
  SAVE_BUTTON_DOCUMENTATION_TAB_VIDEOS = 'aba_videos',
  DOCUMENTATION_TAB_ADDITIONAL = 'aba_outros',
  SAVE_BUTTON_DOCUMENTATION_TAB_ADDITIONAL = 'salvar_outros',
  DOCUMENTATION_FINISH_INITIAL_DOCUMENTATION_NEXT_STEP = 'doc_empresa_prox_etapa',
  SOLVE_PENDENCY = 'resolver_pendencia',
  SOLVED_PENDENCY_ARTICLES_OF_INCORPORATION = 'concluir_contrato',
  SOLVED_PENDENCY_BANK_STATEMENT = 'concluir_extrato',
  SOLVED_PENDENCY_SIMPLES_NACIONAL = 'concluir_simples',
  SOLVED_PENDENCY_BALANCE_SHEET = 'concluir_balanco',
  SOLVED_PENDENCY_DRE = 'concluir_dre',
  SOLVED_PENDENCY_PHOTOS = 'concluir_fotos',
  SOLVED_PENDENCY_VIDEOS = 'concluir_videos',
  SOLVED_PENDENCY_ADDITIONAL = 'concluir_outros'
}
